module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicações pendentes")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed flip-content"
  }, [_c('thead', {
    staticClass: "flip-content"
  }, [_c('tr', [_c('th', {
    staticClass: "col-time align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário programado")])]), _vm._v(" "), _c('th', {
    staticClass: "col-time align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário ministrado")])]), _vm._v(" "), _c('th', {
    staticClass: "align-middle"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno")])]), _vm._v(" "), _c('th', {
    staticClass: "align-middle"
  }, [_c('i', {
    staticClass: "fa fa-medkit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação e Dosagem")])]), _vm._v(" "), _c('th', {
    staticClass: "align-middle"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Motivo")])])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingList.list.length),
      expression: "pendingList.list.length"
    }]
  }, _vm._l((_vm.pendingList.list), function(medicine, index) {
    return _c('tr', [_c('td', {
      staticClass: "prog align-middle",
      class: {
        'font-red bold': _vm.getTimeDiff(medicine.hour) > 0
      }
    }, [(_vm.getTimeDiff(medicine.hour) > 0) ? _c('i', {
      staticClass: "fa fa-exclamation-triangle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(medicine.hour, 'HH:mm', true)) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('form', {
      attrs: {
        "role": "form"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.saveMedicineHour(medicine.id, medicine.takenHour)
        }
      }
    }, [_c('div', {
      staticClass: "input-group",
      class: {
        'has-error': _vm.errors.has(_vm.getTakenHourInputName(index))
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (medicine.takenHour),
        expression: "medicine.takenHour"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('##:##'),
        expression: "'##:##'"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          rules: {
            required: true,
            regex: /^([01]\d|2[0-3]):?([0-5]\d)$/
          }
        }),
        expression: "{ rules: { required: true, regex: /^([01]\\d|2[0-3]):?([0-5]\\d)$/ } }"
      }],
      staticClass: "form-control input-sm",
      attrs: {
        "type": "text",
        "name": _vm.getTakenHourInputName(index),
        "disabled": _vm.isBeforeDate()
      },
      domProps: {
        "value": (medicine.takenHour)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(medicine, "takenHour", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-btn"
    }, [_c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-sm green",
      attrs: {
        "type": "submit",
        "disabled": _vm.errors.has(_vm.getTakenHourInputName(index)) || _vm.isBeforeDate()
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSalvar\n\t\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "width": "25px",
        "height": "25px",
        "src": medicine.student.photoURL
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(medicine.student.name))]), _vm._v(" "), _c('small', {
      staticClass: "font-grey-cascade display-block m-t-5"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Solicitado por")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(medicine.responsible.name) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('span', {
      staticClass: "display-block m-b-10"
    }, [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))]), _vm._v(" "), _c('a', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-link btn-xs",
      attrs: {
        "target": "_blank",
        "href": medicine.medicalPrescriptionURL
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tVer receita\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-xs red-pink",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setReject(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tRejeitar\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('form', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (medicine.reject),
        expression: "medicine.reject"
      }],
      staticClass: "m-t-10",
      attrs: {
        "role": "form"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.rejectionMedicine(medicine.id, medicine.rejectionReason, index)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (medicine.rejectionReason),
        expression: "medicine.rejectionReason"
      }],
      staticClass: "form-control input-sm",
      attrs: {
        "type": "text",
        "placeholder": "Justifique...",
        "required": ""
      },
      domProps: {
        "value": (medicine.rejectionReason)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(medicine, "rejectionReason", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-btn"
    }, [_c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-default btn-sm green",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tJustificar\n\t\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v(_vm._s(medicine.treatment))])])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pendingList.list.length),
      expression: "!pendingList.list.length"
    }]
  }, [_c('tr', [_c('td', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhuma medicação na data informada")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eec88d36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/medicine/medicine-pending/medicine-pending.vue
// module id = 1118
// module chunks = 1